// Remembers the order the shopper just started, so an abandoned checkout is
// recoverable instead of baffling.
//
// The problem this solves: clicking "Continue to payment" creates a real order
// and takes the stock. If they close the Stripe tab, the items are held for the
// checkout window but nothing on the site knows that. They come back, try to
// buy the same card again, and get told it is sold out — by their own order.
// Worse, if they persist they can end up with two orders for one card.
//
// Guests have no account, so the order_token is the only handle that exists.
// localStorage is therefore the right place: same browser, same person, and the
// token is already the credential get_order_by_token checks.

const KEY = 'shinyvault_pending_order';

export function setPendingOrder({ token, url }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ token, url, at: Date.now() }));
  } catch {
    // Private mode or a full quota. The banner is a convenience, not a
    // correctness guarantee — the server still holds the stock either way.
  }
}

export function getPendingOrder() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.token ? parsed : null;
  } catch {
    return null;
  }
}

export function clearPendingOrder() {
  try {
    localStorage.removeItem(KEY);
  } catch { /* nothing to do */ }
}
